import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { OverrideGreenReturnState } from "@redotech/redo-return-ui/flows/return-flow/override-green-return";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const OverrideGreenReturnDetails = memo(
  function OverrideGreenReturnDetails({
    stepSelect,
    state,
    setState,
    flowType,
  }: StepTypeDetailsProps<OverrideGreenReturnState>) {
    const canEditReturnsSettings = useHasPermission(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    );
    const nextStepChange = useHandler((next: StepId | undefined) => {
      setState((state) => ({ ...state, next }));
    });
    const handleGreenReturn = useHandler((greenReturnOverride: boolean) => {
      setState((state) => ({ ...state, greenReturnOverride }));
    });

    return (
      <>
        <RedoToggle
          description={
            state.greenReturnOverride
              ? "Require customer to return item(s),\noverriding by item settings"
              : "Allow customer to keep item(s),\noverriding by item settings"
          }
          disabled={!canEditReturnsSettings}
          label="Require send back"
          setValue={handleGreenReturn}
          value={state.greenReturnOverride}
        />
        <Text fontSize="xs" textColor="secondary">
          Next step
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
      </>
    );
  },
);
